import { camelCase } from 'lodash'
import { FormProp } from '../types'

export const convertData = (data: FormProp) => {
  const cardNumber = data.cardNumber.replace(/-/g, '')
  const cardExpireAt = data.cardExpireAt.split('/')
  return {
    cardNumber,
    cardExpireAt: `20${cardExpireAt[1]}${cardExpireAt[0]}`
  }
}

export function toCamelCase<T>(obj: any): T | T[] {
  if (Array.isArray(obj)) {
    return obj.map((v: T) => toCamelCase<T>(v)) as T[]
  }

  if (obj != null && obj.constructor === Object) {
    // TODO: dung for each thay cho reduce
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: toCamelCase(obj[key])
      }),
      {}
    ) as T
  }
  return obj
}
